import { render, staticRenderFns } from "./promo-popup.vue?vue&type=template&id=db7581d8&scoped=true&"
import script from "./promo-popup.vue?vue&type=script&lang=js&"
export * from "./promo-popup.vue?vue&type=script&lang=js&"
import style0 from "./promo-popup.vue?vue&type=style&index=0&id=db7581d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7581d8",
  null
  
)

export default component.exports